import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setHeaderTitle, setShowHeaderBack } from 'shared/redux/slicers/app.slicer';
import { useAppSelector } from 'shared/redux/store';

export const useSetHeaderTitle = (newHeaderTitle: string) => {
  const dispatch = useDispatch();
  const { headerTitle } = useAppSelector(({ app }) => app);

  const handleSetTitle = (newHeaderTitle: string) => {
    if (headerTitle !== newHeaderTitle) {
      dispatch(setHeaderTitle({ headerTitle: newHeaderTitle }));
    }
  };

  useEffect(() => {
    if (headerTitle !== newHeaderTitle) {
      dispatch(setHeaderTitle({ headerTitle: newHeaderTitle }));
    }
  }, [newHeaderTitle]);

  return {
    handleSetTitle,
  };
};

export const useSetHeaderBack = (newHeaderBack: boolean) => {
  const dispatch = useDispatch();
  const { showHeaderBack } = useAppSelector(({ app }) => app);

  const handleSetHeaderBack = (newHeaderBack: boolean) => {
    if (showHeaderBack !== newHeaderBack) {
      dispatch(setShowHeaderBack({ showHeaderBack: newHeaderBack }));
    }
  };

  useEffect(() => {
    if (showHeaderBack !== newHeaderBack) {
      dispatch(setShowHeaderBack({ showHeaderBack: newHeaderBack }));
    }
  }, [newHeaderBack]);

  return {
    handleSetHeaderBack,
  };
};
